// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Utils = require("../../../utils/Utils.bs.js");
let React = require("react");
let IconV5 = require("./IconV5.bs.js");
let Form__Label = require("./Form__Label.bs.js");
let TailwindMerge = require("tailwind-merge");
let Form__TextInput = require("./Form__TextInput.bs.js");
let JsxRuntime = require("react/jsx-runtime");
let ReactAriaComponents = require("react-aria-components");

function Form$Error(props) {
  return JsxRuntime.jsx("span", {
    children: props.children,
    className: "mt-1.5 text-base leading-4 font-medium text-tan-error-500 block"
  });
}

let $$Error = {
  make: Form$Error
};

function Form$Warning(props) {
  return JsxRuntime.jsx("span", {
    children: props.children,
    className: "mt-1.5 text-base leading-4 font-medium text-yellow-500 block"
  });
}

let Warning = {
  make: Form$Warning
};

function Form$SearchField$SearchFieldGoButton(props) {
  let onPress = props.onPress;
  return JsxRuntime.jsx(ReactAriaComponents.Button, {
    children: JsxRuntime.jsx(IconV5.make, {
      icon: "arrow-right",
      size: 9
    }),
    className: param => "absolute right-[7px] bottom-[7px] pl-[1px] h-5 w-5 rounded-full bg-tan-blue-500 flex items-center justify-center text-white",
    onClick: param => onPress()
  });
}

function Form$SearchField$SearchFieldClearButton(props) {
  let onPress = props.onPress;
  return JsxRuntime.jsx(ReactAriaComponents.Button, {
    children: JsxRuntime.jsx(IconV5.make, {
      icon: "react-select-cancel",
      size: 20
    }),
    className: param => "absolute right-[7px] bottom-[7px] h-5 w-5 flex items-center justify-center text-zinc-400 hover:text-zinc-600",
    onClick: param => onPress()
  });
}

function toArray(str) {
  return str.trim().split(",").map(prim => prim.trim()).filter(str => str !== "");
}

function fromArray(arr) {
  return Utils.$$Array.joinWith(", ", arr);
}

function Form$SearchField(props) {
  let __onFocus = props.onFocus;
  let __onBlur = props.onBlur;
  let __onChange = props.onChange;
  let value = props.value;
  let onChange = __onChange !== undefined ? __onChange : prim => {};
  let onBlur = __onBlur !== undefined ? __onBlur : prim => {};
  let onFocus = __onFocus !== undefined ? __onFocus : prim => {};
  let match = React.useState(() => fromArray(value));
  let setTempValue = match[1];
  let tempValue = match[0];
  React.useEffect(() => {
    setTempValue(param => fromArray(value));
  }, [value]);
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx(Form__TextInput.make, {
        labelText: props.labelText,
        type: "search",
        placeholderText: props.placeholderText,
        grow: true,
        onChange: e => {
          let newValue = e.target.value;
          setTempValue(param => newValue);
        },
        onKeyDown: e => {
          if (e.key === "Enter") {
            return onChange(toArray(tempValue));
          }
        },
        onBlur: e => {
          onBlur(e);
          onChange(toArray(tempValue));
        },
        onFocus: e => onFocus(e),
        value: tempValue
      }),
      tempValue.trim() !== fromArray(value) ? JsxRuntime.jsx(Form$SearchField$SearchFieldGoButton, {
          onPress: () => onChange(toArray(tempValue))
        }) : (
          value.length !== 0 ? JsxRuntime.jsx(Form$SearchField$SearchFieldClearButton, {
              onPress: () => {
                setTempValue(param => "");
                onChange([]);
              }
            }) : null
        )
    ],
    className: "relative flex-grow"
  });
}

function Form$Group(props) {
  let children = props.children;
  let __wide = props.wide;
  let __inline = props.inline;
  let label = props.label;
  let inline = __inline !== undefined ? __inline : true;
  let wide = __wide !== undefined ? __wide : false;
  return JsxRuntime.jsx("div", {
    children: inline ? JsxRuntime.jsxs("div", {
        children: [
          label !== undefined ? JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx(Form__Label.make, {
                labelText: label
              }),
              className: "col-span-12 md:col-span-4 lg:col-span-3 xl:col-span-2"
            }) : null,
          JsxRuntime.jsx("div", {
            children: children,
            className: wide ? "col-span-12 md:col-span-8 lg:col-span-9 xl:col-span-10" : "col-span-12 md:col-span-8 lg:col-span-5 xl:col-span-6"
          })
        ],
        className: "grid grid-cols-12"
      }) : JsxRuntime.jsxs("div", {
        children: [
          label !== undefined ? JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx(Form__Label.make, {
                labelText: label
              }),
              className: "col-span-12"
            }) : null,
          JsxRuntime.jsx("div", {
            children: children,
            className: wide ? "col-span-12 md:col-span-8 lg:col-span-9 xl:col-span-10" : "col-span-12 md:col-span-8 lg:col-span-5 xl:col-span-6"
          })
        ],
        className: "grid grid-cols-12"
      }),
    className: "mb-6 lg:mb-4"
  });
}

let Group = {
  make: Form$Group
};

function Form$Section$SectionTitle(props) {
  return JsxRuntime.jsx("h5", {
    children: props.children,
    className: "pb-2.5 border-b border-zinc-200 mb-6 font-semibold leading-5 text-zinc-700"
  });
}

function Form$Section(props) {
  let __paddingFull = props.paddingFull;
  let tipbox = props.tipbox;
  let title = props.title;
  let paddingFull = __paddingFull !== undefined ? __paddingFull : true;
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsxs("div", {
          children: [
            title !== undefined ? JsxRuntime.jsx(Form$Section$SectionTitle, {
                children: title
              }) : null,
            props.children,
            tipbox !== undefined ? JsxRuntime.jsx("div", {
                children: tipbox,
                className: "mt-4 lg:hidden"
              }) : null
          ],
          className: TailwindMerge.twMerge([
            "bg-white p-[15px] sm:py-[5px] sm:px-5",
            paddingFull ? "sm:p-5" : ""
          ])
        }),
        className: "col-span-12 lg:col-span-9"
      }),
      tipbox !== undefined ? JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx("div", {
              children: tipbox,
              className: "absolute w-full"
            }),
            className: "relative"
          }),
          className: "hidden lg:block col-span-3"
        }) : null
    ],
    className: "grid grid-cols-12 gap-0 lg:gap-4"
  });
}

let Checkbox;

let Switch;

let Label;

let HelpText;

let TextInput;

let TextArea;

let RadioCardList;

let RadioList;

let SearchField = {
  make: Form$SearchField
};

let Section = {
  make: Form$Section
};

exports.Checkbox = Checkbox;
exports.Switch = Switch;
exports.Label = Label;
exports.HelpText = HelpText;
exports.TextInput = TextInput;
exports.TextArea = TextArea;
exports.RadioCardList = RadioCardList;
exports.RadioList = RadioList;
exports.$$Error = $$Error;
exports.Warning = Warning;
exports.SearchField = SearchField;
exports.Group = Group;
exports.Section = Section;
/* Utils Not a pure module */
